import Vue from "vue";
import Vuex from "vuex";
import usercase from "@/store/modules/case";
import flows from "@/store/modules/flows";
import expert from "@/store/modules/expert";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    usercase,
    flows,
    expert,
  },

  state: {
    messages: [],
    viewDoc: null,
    payDialog: false,
  },

  getters: {
    user() {
      return Vue.auth.user();
    },
  },

  mutations: {
    setPayDialog(state, payload) {
      state.payDialog = payload;
    },

    cancelViewDoc(state) {
      state.viewDoc = null;
    },

    openDoc(state, payload) {
      state.viewDoc = payload; // payload: { type: "doc" | "img", url: string }
    },

    addMessage(state, payload) {
      state.messages.unshift(payload);
    },

    deleteMessage(state, id) {
      const index = state.messages.findIndex((message) => message.id === id);
      if (index !== -1) state.messages.splice(index, 1);
    },
  },

  actions: {
    message({ commit }, payload) {
      payload.id = `f${(+new Date()).toString(16)}`;
      commit("addMessage", payload);
    },

    beforeLogout() {
      console.log("logout");
    },
  },
});

export default store;
